import Button from "@mui/material/Button";

export const SettingBtn = ({icon, onClick, sx}: any) => {
  return (
    <Button
    className="setting-btn"
    onClick={onClick}
      sx={{
        ...sx,
        color: "var(--c-text-color)",
        borderRadius: "24px",
        backgroundColor: "var(--c-bg-content-color)",
        border: "2px solid var(--c-bg-content-color)",
        boxShadow:'var(--c-box-shadow-btn)',
        "&:hover": {
          backgroundColor: "var(--c-main-color)",
          boxShadow:'var(--c-box-shadow-btn)',
        },
      }}
      variant="contained"
    >
      {icon}
    </Button>
  );
};
